let chart = {
  option : {
    title: {
        show:false,
        x: 'center',
        text: 'ECharts',
        subtext: 'Rainbow bar example',
        //link: 'http://echarts.baidu.com/doc/example.html'
    },
    tooltip: {
        trigger: 'item',
        formatter: "{b} : {c}"
    },
    toolbox: {
        show: true,
        feature: {
            //dataView: {show: true, readOnly: false},
            //restore: {show: true},
            saveAsImage: {show: true, title:'Pict'}
        }
    },
    calculable: true,
    grid: {
        borderWidth: 0,
        y: 25,
        y2: 25,
        x: 10,
        x2: 10
    },
    xAxis: [
        {
            type: 'category',
            show: true,
            data: ['Line', 'Bar', 'Scatter', 'K', 'Pie', 'Radar', 'Chord', 'Force', 'Map', 'Gauge', 'Funnel']
        }
    ],
    yAxis: [
        {
            type: 'value',
            show: false
        }
    ],
    series: [
        {                
            name: 'bar',
            type: 'bar',                  
            itemStyle: {
                normal: {
            /*        color: function(params) {
                        // build a color map as your need.
                        var colorList = [
                           '#C1232B','#B5C334','#FCCE10','#E87C25','#27727B',
                           '#FE8463','#9BCA63','#FAD860','#F3A43B','#60C0DD',
                           '#D7504B','#C6E579','#F4E001','#F0805A','#26C0C0'
                        ];
                        return colorList[params.dataIndex]
                    },*/
                    label: {
                        show: true,
                        position: 'top',
                        formatter: '{c}'
                    }
                }
            },
            data: [12,21,10,4,12,5,6,5,25,23,7],                  
        }
    ]
  }
}; 

export default chart;

